import { useMemo, useState } from 'react';
import { DisplaySwitch } from '@blockanalitica/ui';
import CapitalAtRiskHistoricGraph from './CapitalAtRiskHistoricGraph';
import CollateralAtRiskGraph from './CollateralAtiRiskGraph';

export default function CollateralAtRiskTabs({ ilk }) {
  const [activeGraph, setActiveGraph] = useState('current');

  const displayOptions = useMemo(
    () => [
      { key: 'current', value: 'Collateral At Risk' },
      { key: 'historic', value: 'Collateral At Risk Historic' }
    ],
    []
  );

  return (
    <>
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeGraph}
        onChange={setActiveGraph}
      />
      {activeGraph === 'current' ? (
        <CollateralAtRiskGraph ilk={ilk} />
      ) : (
        <CapitalAtRiskHistoricGraph ilk={ilk} />
      )}
    </>
  );
}
